import { API_BASE_URL, fetchWithErrorHandling } from "./api";

// Project Management API
export const getProjects = async () => {
  return fetchWithErrorHandling(`${API_BASE_URL}/api/beats/projects/`, {
    method: "GET"
  });
};

export const getProjectById = async (projectId) => {
  return fetchWithErrorHandling(`${API_BASE_URL}/api/beats/projects/${projectId}/`, {
    method: "GET"
  });
};

export const createProject = async (projectData) => {
  return fetchWithErrorHandling(`${API_BASE_URL}/api/beats/projects/`, {
    method: "POST",
    body: JSON.stringify(projectData)
  });
};

export const updateProject = async (projectId, projectData) => {
  return fetchWithErrorHandling(`${API_BASE_URL}/api/beats/projects/${projectId}/`, {
    method: "PUT",
    body: JSON.stringify(projectData)
  });
};

export const deleteProject = async (projectId) => {
  return fetchWithErrorHandling(`${API_BASE_URL}/api/beats/projects/${projectId}/`, {
    method: "DELETE"
  });
};

export const uploadProjectAsset = async (projectId, audioFile, assetType = 'ORIGINAL') => {
  const formData = new FormData();
  formData.append('audio_file', audioFile);
  formData.append('type', assetType);

  try {
    const response = await fetch(`${API_BASE_URL}/api/beats/projects/${projectId}/upload/`, {
      method: "POST",
      body: formData,
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('accessToken')}`
      }
    });

    if (!response.ok) {
      if (response.status === 401 || response.status === 403) {
        // Handle unauthorized access
        throw new Error("Unauthorized access");
      }
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error || "Failed to upload audio asset");
    }

    return response.json();
  } catch (error) {
    console.error("Error uploading audio asset:", error);
    throw error;
  }
};

export const getProjectAssets = async (projectId) => {
  return fetchWithErrorHandling(`${API_BASE_URL}/api/beats/projects/${projectId}/assets/`, {
    method: "GET"
  });
};

// Legacy endpoint for backwards compatibility
export const getBeats = async () => {
  return fetchWithErrorHandling(`${API_BASE_URL}/api/beats/beats/`, {
    method: "GET"
  });
};

// Beats and Chords Generation API
export const generateBeatsChords = async (projectId) => {
  return fetchWithErrorHandling(`${API_BASE_URL}/api/beats/projects/${projectId}/generate-beats-chords/`, {
    method: "POST"
  });
};

export const checkBeatsChordStatus = async (projectId, assetId) => {
  return fetchWithErrorHandling(`${API_BASE_URL}/api/beats/projects/${projectId}/beats-chords-status/${assetId}/`, {
    method: "GET"
  });
};

// Lyrics Generation API
export const generateLyrics = async (projectId) => {
  return fetchWithErrorHandling(`${API_BASE_URL}/api/beats/projects/${projectId}/generate-lyrics/`, {
    method: "POST"
  });
};

export const checkLyricsStatus = async (projectId, assetId) => {
  return fetchWithErrorHandling(`${API_BASE_URL}/api/beats/projects/${projectId}/lyrics-status/${assetId}/`, {
    method: "GET"
  });
};

// Music Identification API
export const generateMusicId = async (projectId) => {
  return fetchWithErrorHandling(`${API_BASE_URL}/api/beats/projects/${projectId}/generate-music-id/`, {
    method: "POST"
  });
};

export const checkMusicIdStatus = async (projectId, assetId) => {
  return fetchWithErrorHandling(`${API_BASE_URL}/api/beats/projects/${projectId}/music-id-status/${assetId}/`, {
    method: "GET"
  });
};

// Auto Master Generation API
export const generateAutoMaster = async (projectId) => {
  return fetchWithErrorHandling(`${API_BASE_URL}/api/beats/projects/${projectId}/generate-automaster/`, {
    method: "POST"
  });
};

export const checkAutoMasterStatus = async (projectId, assetId) => {
  return fetchWithErrorHandling(`${API_BASE_URL}/api/beats/projects/${projectId}/automaster-status/${assetId}/`, {
    method: "GET"
  });
};

// Stem separation endpoints
export const generateStems = async (projectId) => {
  return fetchWithErrorHandling(`${API_BASE_URL}/api/beats/projects/${projectId}/generate-stems/`, {
    method: "POST"
  });
};

export const checkStemsStatus = async (projectId, assetId) => {
  return fetchWithErrorHandling(`${API_BASE_URL}/api/beats/projects/${projectId}/stems-status/${assetId}/`, {
    method: "GET"
  });
};

// curl -X POST "https://api.music.ai//api/job" -H "accept: application/json" -H "Content-Type: application/json" \
//     -H "Authorization: f1f27098-00b2-4280-852e-7c9d239acefc" -d '{"name":"ai-master - demo.ogg","workflow":"workflow-1d53cf2","params":{"inputUrl":"https://music.ai/demo.ogg"}}'